import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {profileData} from "store/reducer/user/profile/selectors";
import {getProfileStart} from "store/reducer/user/profile/reducer";
import {__} from "services/i18n";
import {Icon} from "features/components/icon";
import Text from "features/components/text";
import {resetAuth} from "store/reducer/auth/reducer";
import {historyObject} from "historyObject";
import {ModalPortal} from "features/components/modal";
import Title from "features/components/title";
import Button from "features/components/button";
import {generateFullUrl} from "services/utils/utils";

/* istanbul ignore next */
const mapStateToProps = state => ({
 data: profileData(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getProfileStart,
    resetAuth
};

export const ProfileDropdown = (props) => {
    const {getProfileStart, resetAuth, data} = props;

    const [open, setOpen] = useState(false);

    const toggleOpen = useCallback(() => {
        setOpen(!open);
    }, [open, setOpen]);

    React.useEffect(() => {
        if (!data.firstName){
            getProfileStart();
        }
    }, [data, getProfileStart])

    const image = useMemo(() => {
        if (!data.image) return null;
        return data.image.src || generateFullUrl(data.image);
    }, [data]);

    const goHelp = useCallback(() => {
        historyObject.push("/help");
    }, []);

    const goTo = useCallback((path) => {
        historyObject.push(path);
    }, []);

    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    const logout = useCallback(() => {
        setShowLogoutPopup(true);
    }, [setShowLogoutPopup]);

    return <div className={`profile-dropdown ${open ? "open" : ""}`}>
        <div className="profile" onClick={toggleOpen}>
            <p className="name">{data.firstName} {data.lastName}</p>
            <div className="image">
                {!!image && <img src={image} alt={"profile"} />}
                {!image && <Icon>account-circle</Icon>}
            </div>
        </div>
        <ul className="dropdown">
            <li onClick={() => goTo('/profile')}><Icon>reply-monitor</Icon><Text size={16}>{__("profile-dropdown.osa-profile")}</Text></li>
            <li onClick={() => goTo('/settings')}><Icon>account-circle</Icon><Text size={16}>{__("profile-dropdown.account")}</Text></li>
            <li onClick={() => goTo('/privacy')}><Icon>eye</Icon><Text size={16}>{__("profile-dropdown.privacy")}</Text></li>
            <li onClick={goHelp}><Icon>support</Icon><Text size={16}>{__("profile-dropdown.help")}</Text></li>
            <li className="danger" onClick={logout}><Icon>exit</Icon><Text size={16}>{__("profile-dropdown.logout")}</Text></li>
        </ul>
        {showLogoutPopup && <ModalPortal className="logout-modal">
            <Icon>exit</Icon>
            <Title size={24} align={"center"}>{__("modal.logout.title")}</Title>
            <Text size={16} align={"center"}>{__("modal.logout.text")}</Text>
            <Button title={__("buttons.do-logout")} status={"danger"} onClick={() => resetAuth()} icon={"arrow-right"} />
            <Button title={__("buttons.cancel")} type={"outlined"} onClick={() => setShowLogoutPopup(false)} />
        </ModalPortal>}
    </div>
};
ProfileDropdown.propTypes = {

};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileDropdown);
